import { render, staticRenderFns } from "./UserProfileStatsTime.vue?vue&type=template&id=5f87f098"
import script from "./UserProfileStatsTime.vue?vue&type=script&lang=js"
export * from "./UserProfileStatsTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports